import {
  FETCH_WELD_DATA,
  SET_WELD_DATA,
  SET_WELD_DATA_FAILURE,
  FETCH_WELD_PASSES,
  SET_WELD_PASSES,
  SET_WELD_PASSES_FAILURE,
  CLEAR_WELD_PASSES,
  FETCH_ZONE_VIEW,
  SET_ZONE_VIEW,
  SET_ZONE_VIEW_FAILURE,
  CLEAR_ZONE_VIEW,
  FETCH_TILT_VIEW,
  SET_TILT_VIEW,
  SET_TILT_VIEW_FAILURE,
  CLEAR_TILT_VIEW,
  FETCH_PASS_VIEW_DETAILS,
  SET_PASS_VIEW_DETAILS,
  SET_PASS_VIEW_DETAILS_FAILURE,
  CLEAR_PASS_VIEW_DETAILS,
  FETCH_ZONE_VIEW_DETAILS,
  SET_ZONE_VIEW_DETAILS,
  SET_ZONE_VIEW_DETAILS_FAILURE,
  CLEAR_ZONE_VIEW_DETAILS,
  SET_CURRENT_PROJECT,
  CLEAR_CURRENT_PROJECT,
  FETCH_PROJECTS,
  SET_PROJECTS,
  SET_PROJECTS_FAILURE,
  SET_SELECTED_PROJECT,
  FETCH_SLOGS_REQUEST,
  FETCH_SLOGS_SUCCESS,
  FETCH_SLOGS_FAILURE,
  GENERATE_REPORT_REQUEST,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_FAILURE,
  CLEAR_REPORT_STATUS,
  CLEAR_WELD_DATA,
  FETCH_LIMITS_DATA,
  SET_LIMITS_DATA,
  SET_LIMITS_DATA_FAILURE,
  CLEAR_LIMITS_DATA,
  UPDATE_STATUS_CONFIGURATION,
  UPDATE_STATUS_CONFIGURATION_SUCCESS,
  UPDATE_STATUS_CONFIGURATION_FAILURE,
  CLEAR_ALL_WELD_VIEWS,
  ASSIGN_PIPE_TO_WELD,
  ASSIGN_PIPE_TO_WELD_SUCCESS,
  ASSIGN_PIPE_TO_WELD_FAILURE,
  UPDATE_WELD_NUMBER,
  UPDATE_WELD_NUMBER_SUCCESS,
  UPDATE_WELD_NUMBER_FAILURE,
  MERGE_PASSES,
  MERGE_PASSES_SUCCESS,
  MERGE_PASSES_FAILURE,
  CLEAR_MERGE_PASSES_STATUS,
  CLEAR_RESTORE_MERGED_PASSES_STATUS
} from './types';

const initialState = {
  weldData: [],
  weldPasses: [],
  zoneViewData: [],
  loading: false,
  error: null,
  passesLoading: false,
  passesError: null,
  zoneViewLoading: false,
  zoneViewError: null,
  tiltViewData: [],
  tiltViewLoading: false,
  tiltViewError: null,
  passViewDetails: {},
  passViewDetailsLoading: false,
  passViewDetailsError: null,
  zoneViewDetails: {},
  zoneViewDetailsLoading: false,
  zoneViewDetailsError: null,
  currentProject: null, // Add current project state
  projects: [], // Add projects list
  projectsLoading: false,
  projectsError: null,
  selectedProject: null, // Add selected project for filtering
  slogsData: [], // Add slog data state
  slogsLoading: false, // Add slog loading state
  slogsError: null, // Add slog error state
  // Report generation state
  reportGenerationLoading: false,
  reportGenerationSuccess: false,
  reportGenerationError: null,
  reportGenerationData: null,
  // Limits data state
  limitsData: [],
  limitsLoading: false,
  limitsError: null,
  statusCalculationMethod: 'Instantaneous',
  // Status configuration state
  statusConfiguration: {},
  statusConfigurationLoading: false,
  statusConfigurationError: null,
  statusConfigurationSuccess: false,
  // Assign pipe to weld state
  assignPipeLoading: false,
  assignPipeError: null,
  assignPipeSuccess: false,
  // Update weld number state
  updateWeldNumberLoading: false,
  updateWeldNumberError: null,
  updateWeldNumberSuccess: false,
  // Merge passes state
  mergePassesLoading: false,
  mergePassesError: null,
  mergePassesSuccess: false,
  // Restore (unmerge) state
  restoreMergedPassesLoading: false,
  restoreMergedPassesError: null,
  restoreMergedPassesSuccess: false
};

const weldDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WELD_DATA:
      return {
        ...state,
        loading: true,
        error: null
      };

    case SET_WELD_DATA:
      return {
        ...state,
        weldData: action.weldData,
        loading: false,
        error: null,
        statusCalculationMethod: action.statusCalculationMethod || state.statusCalculationMethod || 'Instantaneous'
      };

    case SET_WELD_DATA_FAILURE:
      console.error('❌ Reducer - SET_WELD_DATA_FAILURE: Setting loading to false', {
        error: action.error
      });
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case FETCH_WELD_PASSES:
      return {
        ...state,
        passesLoading: true,
        passesError: null
      };

    case SET_WELD_PASSES:
      return {
        ...state,
        weldPasses: action.weldPasses,
        passesLoading: false,
        passesError: null
      };

    case SET_WELD_PASSES_FAILURE:
      return {
        ...state,
        passesLoading: false,
        passesError: action.error
      };

    case CLEAR_WELD_PASSES:
      return {
        ...state,
        weldPasses: [],
        passesError: null
      };

    case FETCH_ZONE_VIEW:
      return {
        ...state,
        zoneViewLoading: true,
        zoneViewError: null
      };

    case SET_ZONE_VIEW:
      return {
        ...state,
        zoneViewData: action.zoneViewData,
        zoneViewLoading: false,
        zoneViewError: null
      };

    case SET_ZONE_VIEW_FAILURE:
      return {
        ...state,
        zoneViewLoading: false,
        zoneViewError: action.error
      };

    case CLEAR_ZONE_VIEW:
      return {
        ...state,
        zoneViewData: [],
        zoneViewError: null
      };

    case FETCH_TILT_VIEW:
      return {
        ...state,
        tiltViewLoading: true,
        tiltViewError: null
      };
    case SET_TILT_VIEW:
      return {
        ...state,
        tiltViewData: action.tiltViewData,
        tiltViewLoading: false,
        tiltViewError: null
      };
    case SET_TILT_VIEW_FAILURE:
      return {
        ...state,
        tiltViewLoading: false,
        tiltViewError: action.error
      };
    case CLEAR_TILT_VIEW:
      return {
        ...state,
        tiltViewData: [],
        tiltViewError: null
      };

    case FETCH_PASS_VIEW_DETAILS:
      return {
        ...state,
        passViewDetailsLoading: true,
        passViewDetailsError: null
      };

    case SET_PASS_VIEW_DETAILS:
      return {
        ...state,
        passViewDetails: action.passViewDetails,
        passViewDetailsLoading: false,
        passViewDetailsError: null
      };

    case SET_PASS_VIEW_DETAILS_FAILURE:
      return {
        ...state,
        passViewDetailsLoading: false,
        passViewDetailsError: action.error
      };

    case CLEAR_PASS_VIEW_DETAILS:
      return {
        ...state,
        passViewDetails: {},
        passViewDetailsError: null
      };

    case FETCH_ZONE_VIEW_DETAILS:
      return {
        ...state,
        zoneViewDetailsLoading: true,
        zoneViewDetailsError: null
      };

    case SET_ZONE_VIEW_DETAILS:
      return {
        ...state,
        zoneViewDetails: action.zoneViewDetails,
        zoneViewDetailsLoading: false,
        zoneViewDetailsError: null
      };

    case SET_ZONE_VIEW_DETAILS_FAILURE:
      return {
        ...state,
        zoneViewDetailsLoading: false,
        zoneViewDetailsError: action.error
      };

    case CLEAR_ZONE_VIEW_DETAILS:
      return {
        ...state,
        zoneViewDetails: {},
        zoneViewDetailsError: null
      };

    case SET_CURRENT_PROJECT:
      return {
        ...state,
        currentProject: action.project
      };

    case CLEAR_CURRENT_PROJECT:
      return {
        ...state,
        currentProject: null
      };

    case FETCH_PROJECTS:
      return {
        ...state,
        projectsLoading: true,
        projectsError: null
      };

    case SET_PROJECTS:
      return {
        ...state,
        projects: action.projects,
        projectsLoading: false,
        projectsError: null
      };

    case SET_PROJECTS_FAILURE:
      return {
        ...state,
        projectsLoading: false,
        projectsError: action.error
      };

    case SET_SELECTED_PROJECT:
      return {
        ...state,
        selectedProject: action.project
      };

    // Slog data cases
    case FETCH_SLOGS_REQUEST:
      return {
        ...state,
        slogsLoading: true,
        slogsError: null
      };

    case FETCH_SLOGS_SUCCESS:
      return {
        ...state,
        slogsData: action.payload,
        slogsLoading: false,
        slogsError: null
      };

    case FETCH_SLOGS_FAILURE:
      return {
        ...state,
        slogsLoading: false,
        slogsError: action.payload
      };

    // Report generation cases
    case GENERATE_REPORT_REQUEST:
      return {
        ...state,
        reportGenerationLoading: true,
        reportGenerationSuccess: false,
        reportGenerationError: null,
        reportGenerationData: null
      };

    case GENERATE_REPORT_SUCCESS:
      return {
        ...state,
        reportGenerationLoading: false,
        reportGenerationSuccess: true,
        reportGenerationError: null,
        reportGenerationData: action.payload
      };

    case GENERATE_REPORT_FAILURE:
      return {
        ...state,
        reportGenerationLoading: false,
        reportGenerationSuccess: false,
        reportGenerationError: action.payload,
        reportGenerationData: null
      };

    case CLEAR_REPORT_STATUS:
      return {
        ...state,
        reportGenerationLoading: false,
        reportGenerationSuccess: false,
        reportGenerationError: null,
        reportGenerationData: null
      };

    case CLEAR_WELD_DATA:
      return {
        ...state,
        weldData: [],
        loading: false,
        error: null
      };

    case FETCH_LIMITS_DATA:
      return {
        ...state,
        limitsLoading: true,
        limitsError: null
      };

    case SET_LIMITS_DATA:
      const extractedStatusMethod = action.limitsData?.projectData?.statusCalculationMethod || 'Instantaneous';
      return {
        ...state,
        limitsData: action.limitsData,
        limitsLoading: false,
        limitsError: null,
        // Extract statusCalculationMethod from projectData if available
        statusCalculationMethod: extractedStatusMethod
      };

    case SET_LIMITS_DATA_FAILURE:
      return {
        ...state,
        limitsLoading: false,
        limitsError: action.error
      };

    case CLEAR_LIMITS_DATA:
      return {
        ...state,
        limitsData: [],
        limitsLoading: false,
        limitsError: null,
        statusCalculationMethod: 'Instantaneous'
      };

    case UPDATE_STATUS_CONFIGURATION:
      return {
        ...state,
        statusConfigurationLoading: true,
        statusConfigurationError: null,
        statusConfigurationSuccess: false
      };

    case UPDATE_STATUS_CONFIGURATION_SUCCESS:
      return {
        ...state,
        statusConfigurationLoading: false,
        statusConfiguration: action.payload,
        statusConfigurationSuccess: true,
        statusConfigurationError: null
      };

    case UPDATE_STATUS_CONFIGURATION_FAILURE:
      return {
        ...state,
        statusConfigurationLoading: false,
        statusConfigurationError: action.payload,
        statusConfigurationSuccess: false
      };

    case CLEAR_ALL_WELD_VIEWS:
      return {
        ...state,
        weldPasses: [],
        passesLoading: false,
        passesError: null,
        zoneViewData: [],
        zoneViewLoading: false,
        zoneViewError: null,
        tiltViewData: [],
        tiltViewLoading: false,
        tiltViewError: null,
        passViewDetails: {},
        passViewDetailsLoading: false,
        passViewDetailsError: null,
        zoneViewDetails: {},
        zoneViewDetailsLoading: false,
        zoneViewDetailsError: null
      };

    case ASSIGN_PIPE_TO_WELD:
      return {
        ...state,
        assignPipeLoading: true,
        assignPipeError: null,
        assignPipeSuccess: false
      };

    case ASSIGN_PIPE_TO_WELD_SUCCESS:
      return {
        ...state,
        assignPipeLoading: false,
        assignPipeError: null,
        assignPipeSuccess: true
      };

    case ASSIGN_PIPE_TO_WELD_FAILURE:
      return {
        ...state,
        assignPipeLoading: false,
        assignPipeError: action.payload,
        assignPipeSuccess: false
      };

    case UPDATE_WELD_NUMBER:
      return {
        ...state,
        updateWeldNumberLoading: true,
        updateWeldNumberError: null,
        updateWeldNumberSuccess: false
      };

    case UPDATE_WELD_NUMBER_SUCCESS:
      return {
        ...state,
        updateWeldNumberLoading: false,
        updateWeldNumberError: null,
        updateWeldNumberSuccess: true
      };

    case UPDATE_WELD_NUMBER_FAILURE:
      return {
        ...state,
        updateWeldNumberLoading: false,
        updateWeldNumberError: action.payload,
        updateWeldNumberSuccess: false
      };

    case CLEAR_MERGE_PASSES_STATUS:
      return {
        ...state,
        mergePassesLoading: false,
        mergePassesError: null,
        mergePassesSuccess: false
      };

    case MERGE_PASSES:
      return {
        ...state,
        mergePassesLoading: true,
        mergePassesError: null,
        mergePassesSuccess: false
      };

    case MERGE_PASSES_SUCCESS:
      return {
        ...state,
        mergePassesLoading: false,
        mergePassesError: null,
        mergePassesSuccess: true
      };

    case MERGE_PASSES_FAILURE:
      return {
        ...state,
        mergePassesLoading: false,
        mergePassesError: action.payload,
        mergePassesSuccess: false
      };

    case CLEAR_RESTORE_MERGED_PASSES_STATUS:
      return {
        ...state,
        restoreMergedPassesLoading: false,
        restoreMergedPassesError: null,
        restoreMergedPassesSuccess: false
      };

    case 'RESTORE_MERGED_PASSES':
      return {
        ...state,
        restoreMergedPassesLoading: true,
        restoreMergedPassesError: null,
        restoreMergedPassesSuccess: false
      };

    case 'RESTORE_MERGED_PASSES_SUCCESS':
      return {
        ...state,
        restoreMergedPassesLoading: false,
        restoreMergedPassesError: null,
        restoreMergedPassesSuccess: true
      };

    case 'RESTORE_MERGED_PASSES_FAILURE':
      return {
        ...state,
        restoreMergedPassesLoading: false,
        restoreMergedPassesError: action.payload,
        restoreMergedPassesSuccess: false
      };

    default:
      return state;
  }
};

export default weldDataReducer; 